import type {
  MachineFamily,
  TelemetryData,
  VehicleStatusResponse,
} from "@strtmn/sds/types"
import { getErrorMessage } from "@strtmn/strtmn"
import { I18n } from "aws-amplify/utils"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getVehicleStatus } from "../../api/VehiclesApi"
import { isProd } from "../../config"
import { useMachineFromUserCtx } from "../../hooks"
import { ErrorBanner } from "../MessageBanner"
import VehiclePageLayout from "../VehiclePageLayout"
import Fehlerliste from "./Fehlerliste"
import SoftwareVersions from "./SoftwareVersions"
import StatusDetails from "./StatusDetails"

import "./VehicleDebug.css"

export default function VehicleDebug() {
  const params = useParams<{ vin: string }>()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | undefined>(undefined)
  const [maybeData, setData] = useState<VehicleStatusResponse | undefined>(
    undefined
  )
  const machineFromUserCtx = useMachineFromUserCtx(params.vin!)

  useEffect(() => {
    const getData = async (vin: string) => {
      setError(undefined)
      setData(undefined)
      setLoading(true)
      try {
        const statusData = await getVehicleStatus(vin)
        if (statusData) {
          setData(statusData)
        } else {
          setError("Could not load status data. Unauthenticated.")
        }
      } catch (err) {
        setError(getErrorMessage(err))
      } finally {
        setLoading(false)
      }
    }
    getData(params.vin!)
  }, [params])

  if (loading) {
    return (
      <VehiclePageLayout vin={params.vin!}>Lade Daten...</VehiclePageLayout>
    )
  }

  if (error || !machineFromUserCtx) {
    console.error("Fehler in VehicleDebug")
    return (
      <VehiclePageLayout vin={params.vin!}>
        <ErrorBanner error={I18n.get("Fehler beim Laden der Daten.")} />
        {!isProd && <div>{error}</div>}
      </VehiclePageLayout>
    )
  }
  if (!maybeData) {
    return (
      <VehiclePageLayout vin={params.vin!}>
        <ErrorBanner
          error={I18n.get("Fehler beim Laden der Daten: Keine Daten gefunden")}
        />
        {!isProd && <div>{error}</div>}
      </VehiclePageLayout>
    )
  }

  const data = maybeData
  if (!isProd) {
    console.debug("VehicleDebug: data =", data)
  }
  const telemetryData = data.Telemetry as TelemetryData

  const vehicleFromDdb = machineFromUserCtx.vehicleFromDdb
  const machineType: string =
    machineFromUserCtx.machine_type || vehicleFromDdb?.["m_machineType"] || ""
  const machineTypeLc = machineType.toLowerCase()

  let machineFamily: MachineFamily | undefined
  if (machineTypeLc.startsWith("p")) {
    machineFamily = "primus"
  } else if (
    machineTypeLc.startsWith("everti") ||
    machineTypeLc.startsWith("e-verti")
  ) {
    machineFamily = "e-vertifeed"
  } else if (
    machineTypeLc.startsWith("eprimus") ||
    machineTypeLc.startsWith("e-primus")
  ) {
    machineFamily = "e-primus"
  }

  return (
    <VehiclePageLayout vin={params.vin!}>
      {/* <StandortDetails maschine={data} />
      <br /> */}
      {/* <VerbindungsDetails maschine={data} />
      <br /> */}
      {/* <div><a href='reports/'><button className='reports-link'>Berichte ansehen</button></a></div>
      <br /> */}
      <Fehlerliste
        vin={data.vin!}
        telemetryData={telemetryData}
        maxDisplayLength={10}
        machineFamily={machineFamily}
      />
      <br />
      <SoftwareVersions
        telemetryData={telemetryData}
        machineFamily={machineFamily}
        modemSerial={machineFromUserCtx.modem_serial}
      />
      <br />
      <StatusDetails maschine={data} machineFamily={machineFamily} />
      <br />
      {/* <RulesDetails maschine={data} />
      <br /> */}
      {/* <SonstigeDetails maschine={data} /> */}
    </VehiclePageLayout>
  )
}
